import React from 'react';

import ServicePartnerForm from '../components/ServicePartnerForm';

const AddServicePartner: React.FC = () => {
    return <ServicePartnerForm />;
};

export default AddServicePartner;
